import moment from "moment";
import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { getStudentClassRoomInfo } from "../../../api/students.api";
import useAxios from "../../../hooks/useAxios";
import { getCommonCodeLabel } from "../../../lib/store";
import { IStudentClassInfo, IStudentClassRoomInfo } from "../../../models/students.model";
import ErrorResponse from "../../ErrorResponse";
import Loader from "../../Loader";

const Block = styled.div`
  th, td {
    text-align: center;
  }
`;

interface IProps {
  classInfo?: IStudentClassInfo[];
}

const ClassInfo: FC<IProps> = ({
  classInfo,
}) => {
  const { t, i18n } = useTranslation();
  const { arr: res, isLoading, error, executeArr: execute } = useAxios<any>();

  const [classRooms, setClassRooms] = useState<IStudentClassRoomInfo[]>([]);

  useEffect(() => {
    if (classInfo) {
      const arr: any = [];
      classInfo?.forEach(item => {
        arr.push(getStudentClassRoomInfo(item.classCode));
      });
      execute(arr);
    }
  }, [classInfo]);

  useEffect(() => {
    if (res.length && !isLoading) {
      const _classRooms: IStudentClassRoomInfo[] = [];
      res.forEach(item1 => {
        item1.data.forEach((item2: any) => {
          _classRooms.push(item2);
        });
      })
      setClassRooms(_classRooms);
    }
  }, [res, isLoading]);

  const getClassRoomInfo = (classCode: string|undefined) => {
    if (!classCode) return '';
    const rooms = classRooms.filter(item => item.classCode === classCode);
    const roomNames: any = [];
    rooms.forEach(item => {
      if (!roomNames.includes(item.classRoomName)) {
        roomNames.push(item.classRoomName);
      }
    });
    return roomNames.join(', ');
  }

  return (
    <>
      {isLoading && <Loader />}
      <ErrorResponse error={error} />

      <div className="comm-bx__space">
        <h3 className='sub-title'>{t('student.student.text5')}</h3>
      </div>
      <Block className='comm-table__area'>
        <table>
          <thead>
           <tr>
              <th>{t('student.student.column22')}</th>
              <th>{t('program.semester.column11')}</th>
              <th>{t('student.student.column24')}</th>
              <th>{t('student.student.column25')}</th>
              <th>{t('student.student.column28')}</th>
              <th>{t('student.student.column29')}</th>
              <th>{t('common.column.classroom')}</th>
              <th>{t('student.student.column4')}</th>
            </tr>
          </thead>
          <tbody>
            {classInfo?.map(item => (
              <tr>
                <td>
                  {item.semesterName}
                </td>
                <td>
                  {getCommonCodeLabel('PR0002', item.semesterType, i18n.language)}
                </td>
                <td>
                  {moment(item.srtTimetableDate).format('YYYY.MM.DD')}
                </td>
                <td>
                  {moment(item.endTimetableDate).format('YYYY.MM.DD')}
                </td>
                <td>
                  {item.className}
                </td>
                <td>
                  {item.chargeTeacherKorName}
                </td>
                <td>
                  {getClassRoomInfo(item.classCode)}
                </td>
                <td>
                  {getCommonCodeLabel('CL0003', item.classStudentStatusCode, i18n.language)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Block>
    </>
  );
}

export default ClassInfo;
